import moment from 'moment';

export default angular
  .module('app.formatting')
  .filter('gmwFormatDateTime', gmwFormatDateTime)
  .name;

function gmwFormatDateTime() {
  'ngInject';

  return formatDateTime;

  function formatDateTime(input) {
    if (!input) {
      return input;
    }

    return moment(input).format('YYYY-MMM-DD HH:mm:ss');
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/formatting/filters/format-date-time.js